// Port of api/fuel/app/classes/filter/search/games/filters/query/collection/worth/value.php
import { rangeActive } from 'offline/filter/core/search/unit'
export default {
	name: 'collection.worth.value',
	priority: 77,
	require: function(config, filter) {
		return rangeActive(filter.worth && filter.worth.value, 0, 200)
	},
	run: function(config, filter, data, query) {
		if (filter.worth.value.from > 0) query.where('c.collection_value', '>=', filter.worth.value.from)
		if (filter.worth.value.to < 200) query.where('c.collection_value', '<=', filter.worth.value.to)
	}
}
